<template>
  <div
    v-if="topBarShow"
    class="topBar"
  >
    <img
      class="topBarItem paddingL"
      src="https://imagessl.edujia.com/A-1ed71af7_20231122101853.png"
      @click="closeClick"
    />
    <img
      v-if="from != 'autoSend'"
      class="topBarItem"
      src="https://imagessl.edujia.com/A-1ed71af7_20231122101821.png"
      @click="minClick"
    />
    <img
      v-if="isMax && from != 'autoSend'"
      class="topBarItem"
      src="https://imagessl.edujia.com/A-1ed71af7_20231122101654.png"
      @click="maxClick"
    />
    <img
      v-else-if="!isMax && from != 'autoSend'"
      class="topBarItem"
      src="https://imagessl.edujia.com/A-1ed71af7_20231122101616.png"
      @click="maxClick"
    />
    <span v-if="from != 'setting' && from != 'huashuEdit'">
      <img
        v-if="settingInfo.focusOpen && from != 'autoSend'"
        class="topBarItem"
        src="https://imagessl.edujia.com/A-1ed71af7_20231122101313.png"
        @click="btn1click"
      />
      <img
        v-else-if="!settingInfo.focusOpen && from != 'autoSend'"
        class="topBarItem"
        src="https://imagessl.edujia.com/A-1ed71af7_20231122101435.png"
        @click="btn1click"
      />
      <!-- <img class="topBarItem settingBtn" src="https://imagessl.lingtuo.cn/A-1ed71af7_20240708152333.png" @click="settingClick"/> -->
      <div
        class="settingBtn"
        @click.stop="settingClick"
      >
        <img
          class="topBarItem"
          src="https://imagessl.lingtuo.cn/A-1ed71af7_20241028153737.png"
        />
      </div>
    </span>
    <div
      v-if="title"
      class="title"
    >
      {{ title }}
    </div>
    <!-- <img v-if="islogin" class="faceIcon" :src="faceIcon" @click="userInfoClick"/>  -->
    <!-- <div>
            <el-dialog title="文案显示" custom-class="wenanLineCountDialog" :visible.sync="huashuLineCountDialogShow"
            @close='()=>{this.huashuLineCountDialogShow=false}'>
                <div class="chooseHuashuTypeList">
                    <el-radio-group v-model="tmpWenanShowLineCount" :style="{'display':'grid'}">
                        <el-radio :label="1" :style="{'margin-bottom':'10px'}">最多显示1行内容</el-radio>
                        <el-radio :label="3" :style="{'margin-bottom':'10px'}">最多显示3行内容</el-radio>
                        <el-radio :label="-1" :style="{'margin-bottom':'10px'}">全部显示</el-radio>
                    </el-radio-group>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="wenanLineCountCancel">取 消</el-button>
                    <el-button type="primary" @click="wenanLineCountConfirm">确 定</el-button>
                </div>
            </el-dialog>
        </div> -->
  </div>
  <!-- <div v-else class="topBarWhite"></div> -->
  <div v-else></div>
</template>

<script>
import Vue from "vue";
import { Dialog, Button, Loading, Radio, RadioGroup } from "element-ui";
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Loading);
Vue.use(RadioGroup);
Vue.use(Radio);

export default {
  name: "menubar",
  props: ["from", "title"],
  data() {
    return {
      isMax: false,
      topBarShow: false,
      faceIcon: "",
      pageWidth: document.documentElement.clientWidth,
      huashuLineCountDialogShow: false,
      tmpWenanShowLineCount: 3,
      settingInfo: {},
    };
  },
  computed: {
    islogin() {
      return this.$store.state.token;
    },
  },
  created() {
    if (localStorage.getItem("wenanShowLineCount")) {
      this.tmpWenanShowLineCount = parseInt(
        localStorage.getItem("wenanShowLineCount")
      );
    }

    console.log("menubar...");

    // this.topBarShow = true;
    // return;

    if (this.$common.isElectron()) {
      const { ipcRenderer } = window.require("electron");
      ipcRenderer.send("getSettingInfo");
      let _this = this;
      ipcRenderer.on("getSettingInfoResp", (event, settingInfo) => {
        if (settingInfo) {
          console.log("getSettingInfoResp settingInfo:", settingInfo);
          _this.settingInfo = JSON.parse(settingInfo);
          if (this.isVersionLessThan(_this.settingInfo.version, "1.0.2")) {
            _this.topBarShow = false;
          } else {
            _this.topBarShow = true;
          }
          // _this.applist=_this.settingInfo.applist;
        }
      });
      ipcRenderer.on("clientInfo", (event, args) => {
        // 处理主进程传递过来的参数
        console.log("Received command line args:", args);
        if (this.isVersionLessThan(args.version, "1.0.2")) {
          this.topBarShow = false;
        } else {
          this.topBarShow = true;
        }
      });
      // const { ipcRenderer } = window.require("electron");
      // if (ipcRenderer) {
      //   this.topBarShow = true;
      //   // ipcRenderer.on('clientInfo', (event, args) => {
      //   //   // 处理主进程传递过来的参数
      //   //   console.log('Received command line args:', args);
      //   //   if(this.isVersionLessThan(args.version,'1.0.2')){
      //   //     this.topBarShow=false;
      //   //   }else{
      //   //     this.topBarShow=true;
      //   //   }
      //   // });
      //   ipcRenderer.on("changeFocus", (event, isLock) => {
      //     this.lock = isLock;
      //   });
      // }
    }
    this.faceIcon = localStorage.getItem("edujia:group:web:faceIcon");
  },
  methods: {
    wenanLineCountCancel() {
      this.huashuLineCountDialogShow = false;
    },
    wenanLineCountConfirm() {
      localStorage.setItem("wenanShowLineCount", this.tmpWenanShowLineCount);
      this.$store.commit(
        "modifyWenanShowLineCount",
        this.tmpWenanShowLineCount
      );
      this.huashuLineCountDialogShow = false;
      // this.updateCellStyle();
    },
    settingClick() {
      // this.huashuLineCountDialogShow=!this.huashuLineCountDialogShow;
      const { ipcRenderer } = window.require("electron");
      if (ipcRenderer) {
        ipcRenderer.send("openSetting", this.from);
      }
    },
    userInfoClick() {
      this.$store.commit(
        "modifyLoginDailogShow",
        !this.$store.state.loginDailogShow
      );
    },
    isVersionLessThan(version, targetVersion) {
      // 将版本号拆分成主版本号、次版本号和修订号
      const [currentMajor, currentMinor, currentPatch] = version
        .split(".")
        .map(Number);
      const [targetMajor, targetMinor, targetPatch] = targetVersion
        .split(".")
        .map(Number);

      // 比较主版本号、次版本号和修订号
      if (currentMajor < targetMajor) {
        return true;
      } else if (currentMajor === targetMajor) {
        if (currentMinor < targetMinor) {
          return true;
        } else if (currentMinor === targetMinor) {
          return currentPatch < targetPatch;
        }
      }

      return false;
    },
    minClick() {
      const { ipcRenderer } = window.require("electron");
      if (ipcRenderer) {
        if (this.from == "setting") {
          ipcRenderer.send("settingMin");
        } else if (this.from == "huashuEdit") {
          ipcRenderer.send("huashuEditMin");
        } else {
          ipcRenderer.send("minClick");
        }
      }
    },
    maxClick() {
      this.isMax = !this.isMax;
      const { ipcRenderer } = window.require("electron");
      if (ipcRenderer) {
        if (this.from == "setting") {
          ipcRenderer.send("settingMax");
        } else if (this.from == "huashuEdit") {
          ipcRenderer.send("huashuEditMax");
        } else {
          ipcRenderer.send("maxClick");
        }
      }
    },
    closeClick() {
      const { ipcRenderer } = window.require("electron");
      if (ipcRenderer) {
        if (this.from == "setting") {
          ipcRenderer.send("closeSetting");
        } else if (this.from == "autoSend") {
          ipcRenderer.send("closeAutoSend");
        } else if (this.from == "huashuEdit") {
          ipcRenderer.send("closeHuashuEdit");
        } else {
          ipcRenderer.send("closeClick");
        }
      }
    },
    btn1click() {
      this.settingInfo.focusOpen = !this.settingInfo.focusOpen;
      const { ipcRenderer } = window.require("electron");
      if (ipcRenderer) {
        // ipcRenderer.send("changeFocus");
        // this.settingInfo.applist=this.applist;
        this.$store.commit("modifySettingInfo", this.settingInfo);
        ipcRenderer.send("saveSettingInfo", JSON.stringify(this.settingInfo));
      }
    },
  },
};
</script>
<style>
.el-dialog {
  position: relative;
  margin: 0 auto 50px;
  background: #ffffff;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  width: 50%;
  min-width: 200px;
}
</style>
<style scoped>
.title {
  position: absolute;
  top: 0;
  z-index: 9999;
  left: 50%;
  display: flex;
  justify-content: center;
  transform: translateX(-50%);
}

.paddingL {
  margin-left: 16px;
}

.topBarWhite {
  width: 100%;
  height: 32px;
  background-color: #fff;
  position: absolute;
  left: 0;
  top: 0;
}

.topBar {
  width: 100%;
  min-width: 200px;
  height: 32px;
  /*display: flex;
        align-items: center;*/
  -webkit-app-region: drag;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99999;
  background-image: linear-gradient(180deg, #ececec 0%, #cdcdcd 100%);
}

.topBarItem {
  width: 12px;
  height: 12px;
  border-radius: 20px;
  margin-top: 10px;
  margin-right: 8px;
  -webkit-app-region: no-drag;
}

.faceIcon {
  position: absolute;
  right: 16px;
  top: 4px;
  width: 24px;
  height: 24px;
  border-radius: 24px;
  -webkit-app-region: no-drag;
}

.settingBtn {
  float: right;
  display: flex;
  align-items: center;
  height: 32px;
  margin-right: 10px;
  font-size: 12px;
  color: #3c3c3c;
}

.settingBtn img {
  width: 13px;
  height: 13px;
  margin-top: -2px;
  margin-right: 2px;
}
</style>
